import { CognitoConfig } from '@aslanpay/portal-common-lib';
import appEnv from 'app/config/appEnv';

const authConfig: CognitoConfig = {
  region: appEnv.VITE_COGNITO_REGION,
  userPoolId: appEnv.VITE_COGNITO_USER_POOL_ID,
  userPoolWebClientId: appEnv.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
};

export default authConfig;
